/* eslint-disable @typescript-eslint/no-magic-numbers */
import { MILLISECONDS_IN_MINUTE } from '@/consts';

export const AUTH_SCHEDULE_INTERVAL = 2 * MILLISECONDS_IN_MINUTE;

/**
 * Maximum wall-clock duration for the Cognito session keepalive started by
 * `useOTPFlow.runSignInSchedule`. Must match the backend's
 * `OTP_VALIDITY_MINUTES` (`auth-service/src/dal/dal.py`): once the OTP falls
 * outside that window, every `Auth.signIn` becomes a guaranteed server-side
 * failure.
 */
export const MAX_AUTH_SCHEDULE_DURATION_MS = 60 * MILLISECONDS_IN_MINUTE;

export const RESEND_TIMEOUT = 60;
export const EMAIL_OTP_LENGTH = 6;
export const MFA_CODE_LENGTH = 6;

export const COGNITO_CALL_RETRIES = 3;

export const NETWORK_THROTTLE_USERNAME = 'specterx-otp-network-killer';

export const LAMBDA_TIMEOUT_MESSAGE_PARTIAL = 'socket timeout while invoking lambda function.';

export const codeAuthNameSpace = 'codeAuth';
